import { OverlayToaster as c, Position as e, Intent as a } from "@blueprintjs/core";
import { IconNames as o } from "@blueprintjs/icons";
import "./main.scss";
const n = c.createAsync({
  position: e.TOP,
  className: "sds_toast-overlay"
}), m = ({ message: s, timeout: t = 5e3 }) => {
  (async () => (await n).show({
    className: "sds_toast",
    icon: o.ERROR,
    intent: a.DANGER,
    message: s,
    timeout: t
  }))();
}, I = ({ message: s, timeout: t = 3e3 }) => {
  (async () => (await n).show({
    className: "sds_toast",
    icon: o.INFO_SIGN,
    intent: a.PRIMARY,
    message: s,
    timeout: t
  }))();
}, T = ({ message: s, timeout: t = 3e3 }) => {
  (async () => (await n).show({
    className: "sds_toast",
    icon: o.TAKE_ACTION,
    intent: a.DANGER,
    message: s,
    timeout: t
  }))();
}, w = ({ message: s, timeout: t = 3e3 }) => {
  (async () => (await n).show({
    className: "sds_toast",
    icon: o.TICK_CIRCLE,
    intent: a.SUCCESS,
    timeout: t,
    message: s
  }))();
}, R = ({ message: s, timeout: t = 3e3 }) => {
  (async () => (await n).show({
    className: "sds_toast",
    icon: o.WARNING_SIGN,
    intent: a.WARNING,
    message: s,
    timeout: t
  }))();
};
export {
  m as ErrorToast,
  I as InfoToast,
  T as OutbidToast,
  w as SuccessToast,
  R as WarningToast
};
//# sourceMappingURL=index.js.map
